
export const CHART_TYPE = {
  DONUT: 'donut',
  BAR: 'bar',
  BAR_CHART: 'barchart', 
} as const

export const CHART_VARIANT = {
  LIFECYCLE_STATUS: 'lifecycleStatus',
  OPERATING_STATUS: 'operatingStatus',
  ASSET_AGE: 'assetAge',
  DEFAULT: 'default',
} as const

export const CSS_CLASSES = {
  CHART_BODY: 'cmp-chart-combined__chart-body',
  CHART_BODY_DONUT: 'cmp-chart-combined__chart-body--donut',
  CHART_BODY_BAR: 'cmp-chart-combined__chart-body--bar',
  DONUT: 'cmp-chart-combined__donut',
  BAR: 'cmp-chart-combined__bar',
  CHART_TITLE: 'cmp-chart-combined__chart-title',
  CHART: 'cmp-chart-combined__chart',
  CHARTS_ROW: 'cmp-chart-combined__charts-row',
} as const

export const LAYOUT_CONFIG = {
  maxCharts: 3,
  mobileBreakpoint: 768,
} as const

export const BAR_CHART_CONFIG = {
  scales: {
    small: {
      max: 4,
      step: 1,
    },
    medium: {
      max: 40,
      step: 10,
    },
    large: {
      max: 80,
      step: 20,
    },
  },
  tickCount: 4,
  stepRoundingFactor: 10,
  responsive: {
    mobile: {
      barPercentage: 0.45,
      categoryPercentage: 0.7,
    },
    desktop: {
      barPercentage: 0.6,
      categoryPercentage: 0.8,
    },
  },
} as const

export const DONUT_CHART_CONFIG = {
  cutout: '72%',
  borderWidth: 2,
  legend: {
    position: 'right' as const,
    padding: 14,
  },
} as const

export const TYPOGRAPHY = {
  fontFamily: 'hitachisans-custom, "Hitachi Sans", sans-serif',
  sizes: {
    small: 8,
    mediumSmall: 9,
    medium: 10,
    large: 12,
    xlarge: 14,
  },
  weights: {
    normal: 400,
    bold: 700,
  },
} as const

export const SPACING = {
  tooltip: 12,
  legend: 14,
  tick: {
    mobile: 2,
    desktop: 4,
  },
} as const

export const ROTATION = {
  mobile: 45,
  desktop: 0,
} as const

export const VARIANT_MAPPING: Record<string, string> = {
  'lifecycle-status': CHART_VARIANT.LIFECYCLE_STATUS,
  lifecyclestatus: CHART_VARIANT.LIFECYCLE_STATUS,
  lifecycle: CHART_VARIANT.LIFECYCLE_STATUS,

  'operating-status': CHART_VARIANT.OPERATING_STATUS,
  operatingstatus: CHART_VARIANT.OPERATING_STATUS,
  operating: CHART_VARIANT.OPERATING_STATUS,
  currentoperatingstatus: CHART_VARIANT.OPERATING_STATUS,

  'asset-age': CHART_VARIANT.ASSET_AGE,
  assetage: CHART_VARIANT.ASSET_AGE,
  age: CHART_VARIANT.ASSET_AGE,
}

export const CHART_OPTIONS_BASE = {
  responsive: true,
  maintainAspectRatio: false,
} as const
